export const initialNavigationState = {
    hideNavBar: false
};

// reducer for everything that's loader related
export default function loaderReducer(state = initialNavigationState, action = {type: ''}) {
    if (action.type === 'HIDE_NAVBAR') {
        return {
            ...state,
            hideNavBar: true
        };
    } else if (action.type === 'SHOW_NAVBAR') {
        return {
            ...state,
            hideNavBar: false
        };
    }

    return state;
}
